import { APIGet, IAPIResponse, StatusCode } from "api/protocols";
import { CancelToken } from "axios";
import { IFacilityTeeSheetSettings, IGetFacilityRes } from "../customer/facility";

const apiVersion = "2024-04";
const adminType = "guest";
const baseFacilityUrl = "/" + apiVersion + "/" + adminType + "/facility";

interface IGetFacility {
  id?: number;
  short_name?: string;
  client_id?: number;
  order_by?: string;
  search?: string;
  extended?: boolean;
}
interface IGetFacilityTeeSheetSettingsRes {
  status: StatusCode;
  data: IFacilityTeeSheetSettings;
}

export async function GetFacilityGuest(
  params: IGetFacility,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IGetFacilityRes> {
  return await APIGet(baseFacilityUrl, params, useGlobalLoader, cancelToken);
}

export async function GetGuestTeeSheetSettings(
  params: { facility_id: number },
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IGetFacilityTeeSheetSettingsRes> {
  return await APIGet(baseFacilityUrl + "/settings/tee-sheet", params, useGlobalLoader, cancelToken);
}

export interface IGuestCourseYardage {
  division_id: number;
  yards: number[];
}

export interface IGuestCourseTeeDeck {
  id: number;
  title: string;
  yardages: IGuestCourseYardage[];
}

export interface IGuestCourseDivision {
  id: number;
  title: string;
  holes: number;
  par: number[];
  handicap: number[];
  position: number;
}

export interface IGuestCourseScorecard {
  id: number;
  long_name: string;
  holes: number;
  divisions: IGuestCourseDivision[];
  tee_decks: IGuestCourseTeeDeck[];
}

export async function GetGuestFacilityScorecard(
  params: { facility_id: number },
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<IGuestCourseScorecard[]>> {
  return await APIGet(baseFacilityUrl + "/scorecard", params, useGlobalLoader, cancelToken);
}

export async function GetGuestFacilityStatus(
  params: { facility_id?: string | number; short_name?: string; date?: Date; month?: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet(baseFacilityUrl + "/status", params, useGlobalLoader, token);
}
